/**
 * Brand seal — horizontal frame around the official Desk logo PNG (logo escura.png).
 *
 * The PNG is square with the actual logo (mark + DESK wordmark) centered.
 * We render an oversized image inside an overflow:hidden frame so only the
 * logo content is visible — empty padding gets cropped.
 */
export function LogoHalo({ frameWidth = 380, frameHeight = 144 }) {
    return (
        <div
            style={{
                position: 'relative',
                width: `${frameWidth}px`,
                height: `${frameHeight}px`,
            }}
            className="halo-pulse"
        >
            {/* Decorative bracket frame — drawn on entrance */}
            <svg
                aria-hidden="true"
                viewBox={`0 0 ${frameWidth} ${frameHeight}`}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
                    zIndex: 3,
                }}
            >
                {/* Top-left bracket — forest green */}
                <path className="line-path" d={`M0 28 L0 0 L28 0`} stroke="rgba(22, 101, 52, 0.45)" strokeWidth="1.5" strokeLinecap="round" />
                {/* Bottom-right bracket — forest green */}
                <path className="line-path" d={`M${frameWidth - 28} ${frameHeight} L${frameWidth} ${frameHeight} L${frameWidth} ${frameHeight - 28}`} stroke="rgba(22, 101, 52, 0.45)" strokeWidth="1.5" strokeLinecap="round" />
                {/* Top-right bracket — warm stone */}
                <path className="line-path" d={`M${frameWidth - 28} 0 L${frameWidth} 0 L${frameWidth} 28`} stroke="rgba(28, 25, 23, 0.10)" strokeWidth="1" strokeLinecap="round" />
                {/* Bottom-left bracket — warm stone */}
                <path className="line-path" d={`M0 ${frameHeight - 28} L0 ${frameHeight} L28 ${frameHeight}`} stroke="rgba(28, 25, 23, 0.10)" strokeWidth="1" strokeLinecap="round" />
            </svg>

            {/* Logo container — overflow hidden crops the PNG's empty padding */}
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    zIndex: 2,
                }}
            >
                <img
                    src="/logo escura.png"
                    alt="Desk"
                    style={{
                        width: `${frameWidth * 0.95}px`,
                        height: `${frameWidth * 0.95}px`,
                        objectFit: 'contain',
                        flexShrink: 0,
                    }}
                />
            </div>
        </div>
    );
}
